import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const FooterSection = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    'Property Services': [
      { name: 'Search Properties', path: '/property-search-discovery' },
      { name: 'Rent Properties', path: '/property-search-discovery?type=rent' },
      { name: 'Buy Properties', path: '/property-search-discovery?type=buy' },
      { name: 'Property Valuation', path: '/property-valuation' },
      { name: 'Market Insights', path: '/market-insights' }
    ],
    'Neighborhoods': [
      { name: 'Neighborhood Guide', path: '/neighborhood-intelligence-hub' },
      { name: 'Area Reviews', path: '/area-reviews' },
      { name: 'School Districts', path: '/school-districts' },
      { name: 'Commute Calculator', path: '/commute-calculator' },
      { name: 'Local Amenities', path: '/local-amenities' }
    ],
    'For Owners': [
      { name: 'List Property', path: '/owner-portal' },
      { name: 'Owner Dashboard', path: '/owner-portal/dashboard' },
      { name: 'Pricing Tools', path: '/pricing-tools' },
      { name: 'Marketing Services', path: '/marketing-services' },
      { name: 'Tenant Screening', path: '/tenant-screening' }
    ],
    'Support': [
      { name: 'Help Center', path: '/help' },
      { name: 'Contact Us', path: '/contact' },
      { name: 'Legal Resources', path: '/legal' },
      { name: 'Safety Tips', path: '/safety' },
      { name: 'Report Issue', path: '/report' }
    ]
  };

  const socialLinks = [
    { name: 'Facebook', icon: 'Facebook', url: '#' },
    { name: 'Twitter', icon: 'Twitter', url: '#' },
    { name: 'Instagram', icon: 'Instagram', url: '#' },
    { name: 'LinkedIn', icon: 'Linkedin', url: '#' },
    { name: 'YouTube', icon: 'Youtube', url: '#' }
  ];

 {/* const cities = [
    'Bangalore', 'Mumbai', 'Delhi', 'Chennai', 'Hyderabad', 'Kolkata',
    'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur'
  ];*/}

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
  };

  return (
    <footer className="bg-text-primary text-white">
      {/* Newsletter Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-4">
              Stay Updated with Market Trends
            </h3>
            <p className="text-white/80 max-w-2xl mx-auto">
              Get the latest property insights, market reports, and exclusive listings delivered to your inbox
            </p>
          </div>
          
          <form onSubmit={handleNewsletterSubmit} className="max-w-md mx-auto">
            <div className="flex gap-3">
              <Input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 bg-white/10 border-white/20 text-white placeholder:text-white/60"
                required
              />
              <Button
                type="submit"
                variant="secondary"
                iconName="Send"
                iconPosition="right"
              >
                Subscribe
              </Button>
            </div>
          </form>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/homepage" className="flex items-center space-x-2 mb-6">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Building2" size={20} color="white" />
              </div>
              <span className="text-xl font-bold">Power House</span>
            </Link>
            
            <p className="text-white/80 mb-6 leading-relaxed">
              Your trusted partner in finding the perfect property. We connect property seekers with verified owners through intelligent search and neighborhood insights.
            </p>
            
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-quick"
                  aria-label={social.name}
                >
                  <Icon name={social.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-semibold mb-4">{category}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-white/80 hover:text-white transition-quick text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Cities Section */}
       {/* <div className="mt-12 pt-8 border-t border-white/10">
          <h4 className="font-semibold mb-4">Popular Cities</h4>
          <div className="flex flex-wrap gap-2">
            {cities.map((city) => (
              <Link
                key={city}
                to={`/property-search-discovery?city=${city.toLowerCase()}`}
                className="px-3 py-1 bg-white/10 rounded-full text-sm text-white/80 hover:text-white hover:bg-white/20 transition-quick"
              >
                {city}
              </Link>
            ))}
          </div>
        </div>
        */}
        {/* Contact Info */}
        <div className="mt-8 pt-8 border-t border-white/10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
                <Icon name="Phone" size={20} className="text-primary" />
              </div>
              <div>
                <div className="font-medium">Call Us</div>
                <div className="text-white/80 text-sm">+91 9042160283</div>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-secondary/20 rounded-lg flex items-center justify-center">
                <Icon name="Mail" size={20} className="text-secondary" />
              </div>
              <div>
                <div className="font-medium">Email Us</div>
                <div className="text-white/80 text-sm">powerhouse@gmail.com</div>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-trust-builder/20 rounded-lg flex items-center justify-center">
                <Icon name="MapPin" size={20} className="text-trust-builder" />
              </div>
              <div>
                <div className="font-medium">Visit Us</div>
                <div className="text-white/80 text-sm">Bangalore, India</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="text-white/80 text-sm mb-4 md:mb-0">
              {/* © {currentYear} Power House. All rights reserved. */}
            </div>
            {/*
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/privacy" className="text-white/80 hover:text-white transition-quick">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-white/80 hover:text-white transition-quick">
                Terms of Service
              </Link>
              <Link to="/cookies" className="text-white/80 hover:text-white transition-quick">
                Cookie Policy
              </Link>
              <Link to="/sitemap" className="text-white/80 hover:text-white transition-quick">
                Sitemap
              </Link>
            </div>
            */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;